<div class="devo-donors-donors-view-part">

	<grid-content [setup]="setup" [namedSize]="'TabContent'" [pageTabsGridSize]="pageTabsGridSize()"
		[rows]="donors()"></grid-content>

</div>